<template>
  <div class="search-container">
    <SearchInput />
    <div class="result-container">
      <search-result-block type="community"
                           :results="searchResult.community || []"
      />
      <search-result-block type="post"
                           :results="searchResult.post || []"
      />
      <search-result-block type="user"
                           :results="searchResult.user || []"
      />
      <div class="no-result-container"
           v-if="hasSearched
             && ((searchResult.user||[]).length === 0)
             && ((searchResult.post||[]).length === 0)
             && ((searchResult.community||[]).length === 0)"
      >
        {{ $t('search.search.noResult') }}
      </div>
      <div class="hint-container" v-if="!hasSearched" v-html="$t('search.search.hint')" />
    </div>
  </div>
</template>

<script>
import SearchResultBlock from './SearchResultBlock'
import SearchInput from './SearchInput'
import { mapState } from 'vuex'

export default {
  name: 'SearchInfo',
  components: { SearchResultBlock, SearchInput },
  computed: {
    ...mapState({
      searchResult: state => state.search.searchResult,
      hasSearched: state => state.search.hasSearched
    })
  }
}
</script>

<style scoped lang="scss">
.search-container {
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .result-number {
    margin-left: 20px;
    color: $black-color;
    font-size: 15px;

    .number {
      font-weight: 700;
    }
  }

  .result-container {
    min-width: 600px;
    max-width: 960px;
    width: 100%;
    background: white;

    @media (max-width: $small) {
      min-width: auto;
    }
  }

  .no-result-container, .hint-container {
    padding: 20px;
    background-color: #F2F2F2;
  }
}
</style>
